import { environment } from "src/environments/environment";

export function generateUUID(): string {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = ((d + r) % 16) | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = ((d2 + r) % 16) | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const exportExcel = (data, fileName) => {
  import("xlsx").then((xlsx) => {
    const worksheet = xlsx.utils.json_to_sheet(data);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });
    saveAsExcelFile(excelBuffer, fileName);
  });
};

export const saveAsExcelFile = (buffer, fileName) => {
  import("file-saver").then((FileSaver) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  });
};

export function generateRandomPass(): string {
  const charset = "abcdefghijklmnopqrstuvwxyz0123456789";
  let id = "";
  for (let i = 0, n = charset.length; i < 10; ++i) {
    id += charset.charAt(Math.floor(Math.random() * n));
  }
  return id;
}

export function verifyPhoneNumber(phone: string, showAlert = true): boolean {
  if (!phone || phone.length != 10) {
    if (showAlert) {
      alert("Telefon numarası 10 haneli olmalıdır.");
    }
    return false;
  }

  if (phone.startsWith("0")) {
    if (showAlert) {
      alert("Telefon numarası 0 ile başlamamalı.");
    }
    return false;
  }

  if (!phone.startsWith("5")) {
    if (showAlert) {
      alert("Telefon numarası 5 ile başlamalı.");
    }
    return false;
  }

  if (!phone.match(/^\d+$/)) {
    if (showAlert) {
      alert("Geçerli bir telefon numarası giriniz.");
    }
    return false;
  }

  return true;
}

export function fixStringLength(str: string, fixLen: number) {
  if (str.length <= fixLen) {
    return str;
  }
  return str.substring(0, fixLen) + "...";
}

export function uploadImage(file) {
  return new Promise(async (resolve, reject) => {
    if (file.type.indexOf("image/") > -1) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", environment.cloudinaryPreset);
      const data = await fetch(
        `https://api.cloudinary.com/v1_1/${environment.cloudinaryCloudName}/image/upload`,
        {
          method: "POST",
          body: formData
        }
      ).then((r) => r.json());
      resolve(data.secure_url);
    } else {
      reject({
        message: "Fotoğraf yüklenirken hata oluştu!"
      });
    }
  });
}

export function scrollIntoView(querySelector) {
  const elm = document.querySelector(querySelector);
  if (elm) {
    const elementPosition = elm.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 120;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

export function scrollToTop() {
  setTimeout(() => {
    try {
      (window as any).fbq("track", "PageView");
    } catch {}
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, 100);
}

export function slugify(text: string) {
  return text
    .toLowerCase()
    .replace("i", "ı")
    .replace("ğ", "g")
    .replace("ş", "s")
    .replace("ü", "u")
    .replace("ö", "o")
    .replace(/ /g, "-");
}

export const ascsTanitimCompanyId = "63d37e5ea40fd3584ad3bcbd";
export const sportiveCompanyId = "63e3cb9aa40fd3584ad3d1d0";
export const pickhobiCompanyId = "6433f764cfb35135a7b33114";
export const estmarineCompanyId = "64406d602b3fc0e3388b801f";
export const tatilimSensinCompanyId = "64885bc8b0fea56d8c2140be";
export const aktaslarLezzetCompanyId = "64887aa5b0fea56d8c214625";
export const boostOxygenCompanyId = "649317628bf70e545b622371";
export const leoparCompanyId = "64a93026fe06911fd2208cef";
export const mugoCompanyId = "64abfa8bfe06911fd220d9d5";
export const muhikuCompanyId = "64a42ff0025e254a79215444";
export const belTurCompanyId = "64abdb24fe06911fd220ceab";
export const yasomiCompanyId = "66b339f24e50fc48333049d4";
export const tatilAnketiCompanyId = "66f1653bd3bf28aa14926017";
export const pazanovaCompanyId = "66fa8b1df2f2293e0f6544c3";
export const mydukkanCompanyId = "677ff4ab13f1ea7d1c8793bc";
export const itsbasicCompanyId = "67876b32bfaa2b236a6eedb0";
export const lucidCompanyId = "680219a30c296cea87cd2c6d";
export const peynirciBabaCompanyId = "67db3c538e006ef76de60e04";
export const ekerCompanyId = "64dcb4c08c59ee0ff4c05286";
export const hummelCompanyId = "674d6fa9faa4ffee36afe95d";
export const scooterCompanyId = "66b487fa4e50fc483330aa43";
export const elbisebulCompanyId = "66e35dc3d8ace696f6d5e5b7";
export const kolektifHouseCompanyId = "68e77bad54f8dea4f1b451e9";
export const medCompanyId = "69538538bdccfbf0e0a40abf";
export const teqsmaCompanyId = "6a21ac5d5afc77fffbb1102f";
export const nesPilatesCompanyId = "6ac3eab01b651c9a5e517eda";

export const pickhobiDiscountCode = "pick23";
export const estmarineDiscountCode = "EAST042023";
export const boostOxygenDiscountCode = "Oxygen2023";
export const leoparDiscountCode = "7239";
export const muhikuDiscountCode = "bilgesin15";

export const muhikuUtmLink =
  "https://muhiku.com/?utm_source=bilgesincom&utm_medium=website-anket&utm_campaign=bilgesincom-indirim&utm_term=bilgesincom-indirim&page-header=bilgesincom";

export const landingPageConfig = [
  {
    key: "eker",
    linkButtonText: "market.eker.com'a git",
    linkButtonHref: "https://market.eker.com",
    companyId: ekerCompanyId
  },
  {
    key: "sportive",
    linkButtonText: "sportive.com.tr'ye git",
    linkButtonHref: "https://www.sportive.com.tr",
    companyId: sportiveCompanyId
  },
  {
    key: "scooter",
    linkButtonText: "scooter.com.tr'ye git",
    linkButtonHref: "https://www.scooter.com.tr",
    companyId: scooterCompanyId
  },
  {
    key: "elbisebul",
    linkButtonText: "elbisebul.com'a git",
    linkButtonHref: "https://www.elbisebul.com",
    companyId: elbisebulCompanyId
  },
  {
    key: "yasomi",
    linkButtonText: "yasomi.com.tr'ye git",
    linkButtonHref: "https://www.yasomi.com.tr",
    companyId: yasomiCompanyId
  },
  {
    key: "boost",
    linkButtonText: "boostoxygen.com.tr'ye git",
    linkButtonHref: "https://www.boostoxygen.com.tr",
    companyId: boostOxygenCompanyId
  },
  {
    key: "muhiku",
    linkButtonText: "muhiku.com'a git",
    linkButtonHref: "https://muhiku.com",
    companyId: muhikuCompanyId
  },
  {
    key: "mydukkan",
    linkButtonText: "mydukkan.co'ya git",
    linkButtonHref: "https://mydukkan.co",
    companyId: mydukkanCompanyId
  },
  {
    key: "itsbasic",
    linkButtonText: "itsbasic.com'a git",
    linkButtonHref: "https://www.itsbasic.com",
    companyId: itsbasicCompanyId
  },
  {
    key: "hummel",
    linkButtonText: "hummel.com.tr'ye git",
    linkButtonHref: "https://www.hummel.com.tr",
    companyId: hummelCompanyId
  },
  {
    key: "hummel-2",
    linkButtonText: "hummel.com.tr'ye git",
    linkButtonHref: "https://www.hummel.com.tr",
    companyId: hummelCompanyId
  },
  {
    key: "lucid",
    linkButtonText: "lucidbiyokimya.com'a git",
    linkButtonHref: "https://lucidbiyokimya.com",
    companyId: lucidCompanyId
  },
  {
    key: "peynirci",
    linkButtonText: "Mağaza konumuna ulaşmak için tıklayınız",
    linkButtonHref: "https://maps.app.goo.gl/prKem4yXeDKW8ZnLA",
    companyId: peynirciBabaCompanyId
  },
  {
    key: "kolektif",
    linkButtonText: "kolektifhouse.co'ya git",
    linkButtonHref: "https://koplanet.kolektifhouse.co/login",
    companyId: kolektifHouseCompanyId
  },
  {
    key: "med",
    linkButtonText: "Kurs Merkezi konumuna ulaşmak için tıklayınız",
    linkButtonHref: "https://maps.app.goo.gl/sd6fqvJVF7yYJ4ms8",
    companyId: medCompanyId
  },
  {
    key: "teqsma",
    linkButtonText: "teqsma.com'a git",
    linkButtonHref: "https://www.teqsma.com",
    companyId: teqsmaCompanyId
  },
  {
    key: "nespilates",
    linkButtonText: "Stüdyo konumuna ulaşmak için tıklayınız",
    linkButtonHref: "https://maps.app.goo.gl/4qmUnsGk6BWVrN4M9",
    companyId: nesPilatesCompanyId
  }
];
